'use client';

import { useEffect } from 'react';

import { persistUtmFromSearchParams, resolveUtmFromSearchParams } from '@/lib/tracking/utm-storage';

export { resolveUtmFromSearchParams };

export function useUtmStorage() {
  useEffect(() => {
    persistUtmFromSearchParams(window.location.search);
  }, []);
}
